import { Injectable } from '@angular/core';

import { MatterUser } from '../../models/matter-user';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class MatterUserService {
  /**
   * URL of matter users
   * @type {String}
   */
  private matterUsersURL = 'matter_users';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Allowed to view user income in matter
   * @param  {number}       matterId Id of matter
   * @return {Promise<any>}          Server response with allowed to view permission
   */
  allowedToViewUserIncome(matterId: number): Promise<any> {
    return this.httpClient.get(`${this.matterUsersURL}/user_income.json`, { allowed_to_view: true, matter_id: matterId });
  }

  /**
   * Delete matter user
   * @param  {MatterUser}   matter_user Matter user to delete
   * @return {Promise<any>}             Server response with result
   */
  deleteMatterUser(matter_user: MatterUser): Promise<any> {
    return this.httpClient.delete(`${this.matterUsersURL}/${matter_user.id}.json`);
  }

  /**
   * Get matter users for matter
   * @param  {any}          search_params Search params for matter users
   * @return {Promise<any>}               Server response with matter users
   */
  getMatterUsers(search_params: any): Promise<any> {
    search_params.get_matter_users = true;
    return this.httpClient.get(`${this.matterUsersURL}.json`, search_params);
  }

  /**
   * Get form options for matter users form
   * @return {Promise<any>} [description]
   */
  getFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.matterUsersURL}.json`, { get_form_options: true });
  }

  /**
   * Get users for given matter user type
   * @param  {number}       matter_user_type_id Id of matter user type
   * @return {Promise<any>}                     Server response with users
   */
  getUsers(matter_user_type_id: number): Promise<any> {
    return this.httpClient.get(`${this.matterUsersURL}.json`, { get_users: true, matter_user_type_id: matter_user_type_id });
  }

  /**
   * Get matter user
   * @param  {any}          id Id of matter user
   * @return {Promise<any>}    Server response with matter user
   */
  getMatterUser(id: any): Promise<any> {
    return this.httpClient.get(`${this.matterUsersURL}/${id}.json`, { get_matter_user: true });
  }

  /**
   * Incom
   * @param  {number}       matter_user_id [description]
   * @return {Promise<any>}                [description]
   */
  incomeDue(matter_user_id: number, params: any = {}): Promise<any> {
    params.income_due = true;
    return this.httpClient.get(`${this.matterUsersURL}/${matter_user_id}/user_income.json`, params);
  }

  /**
   * Save matter user
   * @param  {MatterUser}   matter_user Matter user to save
   * @return {Promise<any>}             Server response with result
   */
  saveMatterUser(matter_user: MatterUser): Promise<any> {
    if (matter_user.id) return this.httpClient.put(`${this.matterUsersURL}/${matter_user.id}.json`, { matter_user: matter_user, save_matter_user: true });
    else return this.httpClient.post(`${this.matterUsersURL}.json`, { matter_user: matter_user, save_matter_user: true });
  }

  shareOfIncome(matter_user_id: number): Promise<any> {
    return this.httpClient.get(`${this.matterUsersURL}/${matter_user_id}/user_income.json`, { share_of_income: true });
  }

  userIncome(matter_user_id: number): Promise<any> {
    return this.httpClient.get(`${this.matterUsersURL}/${matter_user_id}/user_income.json`);
  }
}
